import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { InputEl } from "common/components/input";
export function template() {
  const { isEditing, currText } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".text-editor" }, !isEditing ? /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".text-wrapper",
      class: {
        "editable-text": !this.attr(`disable-edit`),
        "show-hover": !this.attr(`disable-edit`) && this.attr(`show-hover-state`)
      },
      on: { click: (ev) => this.attr(`disable-edit`) ? null : this.helpers.handleEditingStart(ev) },
      attrs: { elref: `editableTextWrapper` }
    },
    /* @__PURE__ */ jsx("slot", { attrs: { name: `content` } })
  ) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(
    InputEl,
    {
      attrs: {
        type: `textarea`,
        value: currText,
        placeholder: this.attr(`placeholder`),
        maxlength: this.attr(`max-chars`),
        size: this.attr(`size`),
        elref: `editableTextInput`
      },
      on: {
        input: this.helpers.handleValueChange,
        blur: this.helpers.handleSaveByBlur,
        keydown: this.helpers.handleSaveByKeyPress
      },
      props: {
        value: currText
      },
      hook: {
        insert: this.helpers.handleInputInserted
      }
    }
  ), !this.attr(`hide-footer`) ? /* @__PURE__ */ jsx("div", { sel: ".text-editor-footer" }, /* @__PURE__ */ jsx(ButtonEl, { on: { click: this.helpers.handleCancelEdit } }, "Cancel"), /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".save-button",
      attrs: {
        theme: ButtonTheme.Primary,
        disabled: !this.helpers.textChanged()
      },
      on: { click: this.helpers.handleSaveByButton }
    },
    "Save"
  )) : null));
}
